import {baseApi} from '../../rest'
import {ImportSitesRequest, ImportSitesResult} from './state'

export const siteImportApi = {
  ...baseApi,
  async importSites(body: ImportSitesRequest): Promise<ImportSitesResult> {
    const request = await this.doRequest<ImportSitesResult>({
      path: '/organisation/site/import',
      payload: body
    })
    const response = await request.post()
    return (response.data as unknown) as ImportSitesResult
  }
}
